module.exports = __webpack_public_path__ + "img/new_beneficiaire.4c31f585.png";